// extracted by mini-css-extract-plugin
export default {"container":"detail_container__sVnA9","table":"detail_table__Br+w7","ulSAP":"detail_ulSAP__E6h1B","liSAP":"detail_liSAP__dlZY+","spanSAP":"detail_spanSAP__6c1vT"};